import React from 'react';
import { Facebook, Twitter, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black border-t border-gold-500/30 pt-16 pb-8" data-id="element-117">
      <div className="container mx-auto px-4" data-id="element-118">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 mb-12" data-id="element-119">
          <div className="col-span-1 md:col-span-2" data-id="element-120">
            <h2 className="text-gold-500 font-serif text-2xl mb-4" data-id="element-121">
              SGLonelyGuy
            </h2>
            <p className="text-gray-500 max-w-sm mb-6" data-id="element-122">
              新加坡首选的高端伴游服务平台。致力于为都市精英提供私密、安全、高品质的社交体验。
            </p>
            <div className="flex space-x-4" data-id="element-123">
              <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors" data-id="element-124">
                <Facebook className="w-5 h-5" data-id="element-125" />
              </a>
              <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors" data-id="element-126">
                <Twitter className="w-5 h-5" data-id="element-127" />
              </a>
              <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors" data-id="element-128">
                <Instagram className="w-5 h-5" data-id="element-129" />
              </a>
            </div>
          </div>

          <div data-id="element-130">
            <h3 className="text-white font-medium mb-4 uppercase tracking-wider text-sm" data-id="element-131">
              快速链接
            </h3>
            <ul className="space-y-2" data-id="element-132">
              <li data-id="element-133">
                <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-134">
                  关于我们
                </a>
              </li>
              <li data-id="element-135">
                <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-136">
                  服务项目
                </a>
              </li>
              <li data-id="element-137">
                <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-138">
                  精选伴游
                </a>
              </li>
              <li data-id="element-139">
                <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-140">
                  会员权益
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-141">
            <h3 className="text-white font-medium mb-4 uppercase tracking-wider text-sm" data-id="element-142">
              法律信息
            </h3>
            <ul className="space-y-2" data-id="element-143">
              <li data-id="element-144">
                <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-145">
                  使用条款
                </a>
              </li>
              <li data-id="element-146">
                <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-147">
                  隐私政策
                </a>
              </li>
              <li data-id="element-148">
                <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-149">
                  免责声明
                </a>
              </li>
              <li data-id="element-150">
                <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-151">
                  联系我们
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-152">
            <h3 className="text-white font-medium mb-4 uppercase tracking-wider text-sm" data-id="element-153">
              友站链接
            </h3>
            <ul className="space-y-2" data-id="element-154">
              <li data-id="element-155">
                <a href="https://ttvip-64.com/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-156">
                  ttvip-64.com
                </a>
              </li>
              <li data-id="element-157">
                <a href="https://shiok27.com/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-158">
                  shiok27.com
                </a>
              </li>
              <li data-id="element-159">
                <a href="https://xfy01.net/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-160">
                  xfy01.net
                </a>
              </li>
              <li data-id="element-161">
                <a href="https://sgharem6.net/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-162">
                  sgharem6.net
                </a>
              </li>
              <li data-id="element-163">
                <a href="https://qc52.me/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-164">
                  qc52.me
                </a>
              </li>
              <li data-id="element-165">
                <a href="https://sglonelyguy.me/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-166">
                  sglonelyguy.me
                </a>
              </li>
              <li data-id="element-167">
                <a href="https://ttvip.life/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-168">
                  ttvip.life
                </a>
              </li>
              <li data-id="element-169">
                <a href="https://locanto.space/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-170">
                  locanto.space
                </a>
              </li>
              <li data-id="element-171">
                <a href="https://kkbaby.site/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-172">
                  kkbaby.site
                </a>
              </li>
              <li data-id="element-173">
                <a href="https://xfy8.com/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-174">
                  xfy8.com
                </a>
              </li>
              <li data-id="element-175">
                <a href="https://sgbeautycastle.live/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-176">
                  sgbeautycastle.live
                </a>
              </li>
              <li data-id="element-177">
                <a href="https://shiok26.site/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-178">
                  shiok26.site
                </a>
              </li>
              <li data-id="element-179">
                <a href="https://sgharem.site/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-180">
                  sgharem.site
                </a>
              </li>
              <li data-id="element-181">
                <a href="https://shiok8.xyz/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-182">
                  shiok8.xyz
                </a>
              </li>
              <li data-id="element-183">
                <a href="https://geylang777.info/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-184">
                  geylang777.info
                </a>
              </li>
              <li data-id="element-185">
                <a href="https://ttvip-62.site/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-186">
                  ttvip-62.site
                </a>
              </li>
              <li data-id="element-187">
                <a href="https://geylang666.me/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-188">
                  geylang666.me
                </a>
              </li>
              <li data-id="element-189">
                <a href="https://isyou.net/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-190">
                  isyou.net
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-191">
          <p className="text-gray-600 text-xs mb-4 md:mb-0" data-id="element-192">
            &copy; {new Date().getFullYear()} SGLonelyGuy. All rights reserved.
          </p>
          <div className="flex items-center gap-2 text-gray-600 text-xs border border-white/10 px-3 py-1 rounded" data-id="element-193">
            <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse" data-id="element-194"></span>
            <span data-id="element-195">Adults Only 18+</span>
          </div>
        </div>
      </div>
    </footer>;
}